import React from 'react';
import Layout from '@codedrop/layout/esm/layout';
import Block from '@codedrop/block/esm/block';

let Graphic = () => /*#__PURE__*/React.createElement("div", null, "Graphic");

const BlockGraphic = ({
  title,
  subtitle,
  graphic,
  children,
  reverse = false
}) => {
  if (graphic) {
    Graphic = () => {
      const graphicFile = require("../images/".concat(graphic));

      return graphicFile.default();
    };
  }

  return /*#__PURE__*/React.createElement(Layout, {
    className: "section--top-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block-graphic grid ".concat(reverse ? 'block-graphic--reverse' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid__col grid--6-col"
  }, /*#__PURE__*/React.createElement(Block, {
    title: {
      tag: 'h2',
      text: title
    },
    subtitle: {
      tag: 'h3',
      text: subtitle
    }
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: "grid__col grid--6-col block-graphic__graphic-wrapper"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "block-graphic__graphic block-graphic__graphic--".concat(graphic.replace('.svg', ''))
  }, /*#__PURE__*/React.createElement(Graphic, null)))));
};

BlockGraphic.displayName = 'BlockGraphic';
export default BlockGraphic;